import { get } from 'lodash';

// local dependencies
import { HttpService } from 'core/modules/network-service';
import { SERVICE_RESPONSE_STATUS } from 'constants/common';

/*************************************************************/
/**
 * @type {class}
 * @desc CallWidgetCategoryReasonSummary defines an HTTP service interface to send HTTP network requets.
 * @example
 * import { CallWidgetCategoryReasonSummaryService } from 'services/callWidgetCategoryReasonSummary';
 *
 * // create service instance and send/cancel request
 * const callWidgetCategoryReasonSummaryService = new CallWidgetCategoryReasonSummaryService();
 * const result = await callWidgetCategoryReasonSummaryService.fetchData( '<user-id>' ); // fetch data
 * callWidgetCategoryReasonSummaryService.cancel(); // cancel an active request
 */
export class CallWidgetCategoryReasonSummaryService extends HttpService {

    // make request and fetch data
    async fetchComponentData( { url = {}, data = {} } = {} ) {
        try {
            const response = await this.post( {
                host: CONFIG.host,
                path: url,
                data,
            } );
            
            const widget = get( response, 'body.component.structure.widgetConfig', [] );
            const items = get( response, 'body.component.data.state.items', [] );
            const options = get( response, 'body.component.data.options.categoryAndReason', [] );
            const pagination = get( response, 'body.component.data.pagination', [] );
            const paginationConfig = get( response, 'body.component.structure.paginationConfig', [] );
            
            return {
                status: get( response, 'body.status', SERVICE_RESPONSE_STATUS.FAILURE ),
                data: {
                    ...get( response, 'body.component', {}, ), widget, pagination, paginationConfig,
                items, options
            },
               
                        };

        } catch( error ) {
            return {
                status: SERVICE_RESPONSE_STATUS.FAILURE,
                data: null,
            };
        }
    }
}
